<!-- 登录 -->
<template>
    <el-container class="login-container">
        <div class="form-container">
            <el-card class="login-card">
                <div class="transform-center between header-tab">
                    <span
                        class="pointer"
                        >企业用户</span
                    >
                </div>

                <component :is="componentName"></component>
            </el-card>
        </div>
    </el-container>
</template>

<script>
import Ukey from "./ukey-login.vue";


export default {
    name: "LoginContainer",
    components: { Ukey },
    data() {
        return {
            componentName: 'Ukey',
        };
    },
    computed: {
    }
};
</script>

<style lang="less">
.login-container {
    height: 50%;

    .login-container__footer {
        position: fixed;
        bottom: 0;
        width: 100%;
        text-align: right;
        padding: 20px;
        color: @grey;
    }

    .form-container {
        display: block;
        height: 540px;
        margin: calc((100vh - 800px) / 2) auto;
    }
    .login-tips {
        position: relative;
        width: 540px;
        height: 20px;
        white-space: nowrap;
        overflow: hidden;
        color: red;
    }
    .tips-content {
        position: absolute;
        bottom: 2px;
    }
    .name-bar {
        font-size: 24px;
        font-weight: 600;
        margin-bottom: 40px;
    }

    .login-card {
        padding: 44px 44px;
        width: 540px;

        .el-card__body {
            padding: 0;
        }
    }

    .header-tab {
        margin: 0 auto 28px;
        width: 80%;
        display: flex;
        justify-content: center;
        span {
            display: inline-block;
            line-height: 25px;
            padding: 4px 20px;
            font-size: 16px;
            font-weight: 400;
            border-bottom: 2px solid transparent;

            &.is-active {
                border-bottom-color: @primary;
            }
        }
    }

    .tips {
        margin-top: 24px;
        padding: 12px 13px;
        line-height: 17px;
        background: rgb(235, 245, 254);
        border-radius: 5px;
        font-size: 12px;
        color: rgb(149, 156, 164);
    }
}
</style>
